/** Nachweise für per Code bestätigte E-Mail-Adressen (je Feld; gilt nur, solange die Adresse gleich bleibt). */
const proofs = new Map<string, { email: string; proof: string }>();
const norm = (s: unknown) => (typeof s === "string" ? s.trim().toLowerCase() : "");

export const setProof = (fieldId: string, email: string, proof: string) => proofs.set(fieldId, { email: norm(email), proof });
export const isVerified = (fieldId: string, email: unknown) => !!norm(email) && proofs.get(fieldId)?.email === norm(email);
export function verifications(answers: Record<string, unknown>): Record<string, string> | undefined {
  let out: Record<string, string> | undefined;
  for (const [id, p] of proofs) if (p.proof && norm(answers[id]) === p.email) (out ??= {})[id] = p.proof;
  return out;
}
/** Selbstbearbeitung: bereits gespeicherte Adressen gelten als bestätigt (ohne neuen Nachweis). */
export const markKnown = (answers: Record<string, unknown>) => {
  for (const [id, v] of Object.entries(answers)) if (typeof v === "string" && v.includes("@")) proofs.set(id, { email: norm(v), proof: "" });
};
